<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" 
        :visible="visible" 
        :confirmLoading="loading" 
        @cancel="cancel" 
        @ok="confirm">
      <div slot="title">{{ isReadonly ? "查看" : (form.id ? "编辑" : "新增") }}</div>
        <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model ref="form" :model="form.others" :rules="isReadonly ? {} : rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="check_date" label="检查日期">
            <a-date-picker v-model="form.others.check_date" format="YYYY-MM-DD" style="width: 100%" :disabled="isReadonly" @change="chooseDate" />
          </a-form-model-item>
          <a-form-model-item prop="control_date" label="管控日期范围">
            <a-range-picker v-model="form.others.control_date" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="record_code" label="记录编号">
            <a-input v-model="form.others.record_code" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="review" label="上周回顾">
            <a-textarea v-model="form.others.review" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="troubleshooting" label="本周排查">
            <a-textarea v-model="form.others.troubleshooting" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="measures" label="整改措施">
            <a-textarea v-model="form.others.measures" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-textarea v-model="form.others.remark" :disabled="isReadonly" />
          </a-form-model-item>
          <a-form-model-item prop="participants" label="参加人员">
            <a-select v-model="form.others.participants" mode="multiple" placeholder="请选择参加人员" style="width: 100%" :disabled="isReadonly">
              <a-select-option v-for="item in userList" :key="item.id" :value="item.name">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </div>
      
      <!-- 打印容器 -->
      <div class="weekly-print-container">
        <div id="weeklyPrint">
          <PrintDetail :form="form" />
        </div>
      </div>
      
      <template #footer>
        <a-button v-if="form.id" key="print" type="primary" v-print="printOptions">
          打印
        </a-button>
        <a-button v-if="!isReadonly" key="submit" type="primary" :loading="loading" @click="confirm">
          {{ form.id ? '保存' : '新增' }}
        </a-button>
        <a-button key="cancel" @click="cancel">
          {{ isReadonly ? '关闭' : '取消' }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { weekControlAdd, weekControlEdit } from "@/api/control";
import { userList } from "@/api/account"; // 导入获取用户列表的API
import moment from 'moment';
import PrintDetail from "./print-detail.vue";

export default {
  name: "FormModal",
  components: {
    PrintDetail
  },
  props: ["visible", "form", "clientsClassificationOptions", "isReadonly"],
  data() {
    return {
      printOptions: {
        id: "weeklyPrint",
        popTitle: "周排查打印",
        extraHead: "",
      },
      levelOptions: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
      ],
      rules: {
        check_date: [
          { required: true, message: "请选择检查日期", trigger: "change" }
        ]
      },
      loading: false,
      userList: [], // 添加用户列表数据
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 当模态框打开时，转换日期格式
        this.normalizeDateFields();
      }
    }
  },
  mounted() {
    this.getUserList(); // 组件挂载时获取用户列表
  },
  methods: {
    normalizeDateFields() {
      if (this.form && this.form.others) {
        // 转换检查日期
        if (this.form.others.check_date && typeof this.form.others.check_date === 'string') {
          this.form.others.check_date = moment(this.form.others.check_date);
        }
        
        // 转换管控日期范围
        if (this.form.others.control_date) {
          if (typeof this.form.others.control_date === 'string') {
            try {
              const dates = JSON.parse(this.form.others.control_date);
              if (Array.isArray(dates) && dates.length === 2) {
                this.form.others.control_date = [moment(dates[0]), moment(dates[1])];
              }
            } catch (e) {
              console.error('解析管控日期范围失败:', e);
            }
          } else if (Array.isArray(this.form.others.control_date)) {
            // 如果已经是数组，确保每个元素都是moment对象
            this.form.others.control_date = this.form.others.control_date.map(date => 
              typeof date === 'string' ? moment(date) : date
            );
          }
        }
      }
    },
    getUserList() {
      userList({ page_size: 999 }).then(response => {
        this.userList = response.results || []; // 根据API响应格式调整
      }).catch(error => {
        console.error("获取用户列表失败:", error);
      });
    },
    chooseDate(data, dateString) {
      this.form.others.check_date = dateString
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let func = this.form.id ? weekControlEdit : weekControlAdd;
          func(this.form)
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "新增成功");
              this.$emit(this.form.id ? "update" : "create");
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      if(!this.form.id) {
        this.$refs.form.resetFields();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.weekly-print-container {
  position: absolute;
  left: -9999px;
  top: 0;
  visibility: hidden;
}
</style>
